export let exportRefundTableHeader = [
  {key: 'payment_company_name', text: '付款公司抬头'},
  {key: 'id', text: '付款退款单单号'},
  {key: 'status_name', text: '付款状态'},
  {key: 'creator_info', text: '创建人'},
  {key: 'department_name', text: '创建人部门'},
  {key: 'apply_payment_type_name', text: '付款类型'},
  {key: 'refund_desc', text: '退款说明'},
  {key: 'receipt_name', text: '收款方名称'},
  {key: 'bank_account', text: '银行账号'},
  {key: 'bank', text: '开户银行支行'},
  {key: 'bank_headquarters', text: '开户银行总行'},
  {key: 'refund_amount_total', text: '退款金额'},
  {key: 'refund_date', text: '退款日期'},
]

export let exportRefundDetailHeader = [
  {key: 'payment_company_name', text: '付款公司抬头'},
  {key: 'id', text: '付款退款单单号'},
  {key: 'status_name', text: '付款状态'},
  {key: 'creator_info', text: '创建人'},
  {key: 'department_name', text: '创建人部门'},
  {key: 'apply_payment_type_name', text: '付款类型'},
  {key: 'refund_desc', text: '退款说明'},
  {key: 'status_name', text: '付款状态'},
  {key: 'detail_refund_amount', text: '退款金额'},
  {key: 'detail_paid_amount', text: '含税实付金额'},
  {key: 'detail_project_name', text: '项目名称'},
  {key: 'detail_project_number', text: '项目编号'},
  {key: 'detail_department_name', text: '费用承担部门'},
  {key: 'detail_first_subject_name', text: '一级科目'},
  {key: 'detail_second_subject_name', text: '二级科目'},
  {key: 'detail_invoice_type_name', text: '发票类型'},
  {key: 'detail_tax_rate', text: '税率'},
  {key: 'detail_apply_desc', text: '付款申请摘要'},
  {key: 'refund_date', text: '退款日期'},
  {key: 'receipt_name', text: '收款方名称'},
  {key: 'bank_account', text: '银行账号'},
  {key: 'bank', text: '开户银行支行'},
  {key: 'bank_headquarters', text: '开户银行总行'},
]

export let exportRefundSummaryHeader = [
  {key: 'name', text: '状态'},
  {key: 'refund_total', text: '付款退款总金额'},
]



// WEBPACK FOOTER //
// ./src/views/payment-refund/payment-refund-export-header.js